//#region imports
import customAxios from '../../utils/customAxios';
import { formatDateDDMMYYYY } from '../../utils/dateFormat';
import React, { useState, useEffect } from 'react';

import { DataGridPro, GridToolbar } from '@mui/x-data-grid-pro';

import ModalCDelete from '../Modal/Delete/ModalCDelete';
import ModalCActivate from '../Modal/Activate/ModalCActivate';
import { useNavigate } from 'react-router-dom';
import { IconButton, Tooltip } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAdd,
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
} from '@fortawesome/free-solid-svg-icons';

import { DeleteOutlineOutlined as DeleteIcon } from '@mui/icons-material';

import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

import ModalCMultDelete from '../Modal/Delete/Multiple/ModalCMultDelete';
import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import ModalC from '../Modal/Create/ModalC';
import { GlobalVariables } from '../../globalVar';
import { useTour } from '@reactour/tour';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import useClientsTour from '../../tours/clientsTour';

import ModalCUpdate from '../Modal/Update/ModalCUpdate';
import { useTableLocale } from '../../hooks/useTableLocale';
import { useUserPermissions } from '../../hooks/userPermissions';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
);

//#endregion

export const ClientsTableAxios = () => {
  const userPermissions = useUserPermissions();
  // Config de hooks
  const [clientData, setClientData] = useState([]);

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const {
    clientsString,
    clientContactNameString,
    clientClientString,
    clientStatusString,
    noClientsString,
    multDeleteString,
    addString,
    detailString,
    editString,
    logsString,
    deleteString,
    viewTutorialString,
    createdAtString,
    createdByString,
    updatedAtString,
    updatedByString,
    clientMCCompanyNameString,
  } = useTranslationHook();

  const [modalCShow, setModalCShow] = useState(false);
  const [modalCDeleteShow, setModalCDeleteShow] = useState(false);
  const [modalSActivateShow, setModalSActivateShow] = useState(false);

  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const clientsTour = useClientsTour(setModalCShow);

  const locale = useTableLocale();

  useEffect(() => {
    // Check if clientsTour has not been viewed
    const hasSeenTour = localStorage.getItem('clientsTourViewed');

    if (userPermissions.includes('Create Clients') && !hasSeenTour) {
      setIsOpen(true);
      setSteps(clientsTour);
      setCurrentStep(0);
      // clientsTour viewed
      localStorage.setItem('clientsTourViewed', 'true');
    }
  }, [userPermissions, setIsOpen, setSteps]);

  const restartTour = () => {
    setIsOpen(true);
    setSteps(clientsTour);
    setCurrentStep(0);
    localStorage.setItem('clientsTourViewed', 'false');
  };

  useEffect(() => {
    const updateClientData = () => {
      setClientData((prevData) => {
        return prevData.map((client) => ({
          ...client,
          is_active: t(`${client.is_active}`),
        }));
      });
    };
    i18next.on('languageChanged', updateClientData);

    return () => {
      i18next.off('languageChanged', updateClientData);
    };
  }, [t]);

  const endpoint = `${GlobalVariables.getURL()}listClients`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const clientData = response.data.map((client) => {
        return {
          ...client,
          is_active: t(`${client.is_active}`),
        };
      });
      setClientData(clientData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  const navigate = useNavigate();

  const [modalCUpdateShow, setModalCUpdateShow] = useState(false);

  function manageClientUpdate(clientInfo) {
    return new Promise((resolve, reject) => {
      var business_name = clientInfo.business_name;
      var client_id = clientInfo.id;
      localStorage.setItem('business_name', business_name);
      localStorage.setItem('client_id', client_id);

      customAxios
        .get(`${GlobalVariables.getURL()}autofillClient/${client_id}`, {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        })
        .then((response) => {
          var clientData = response.data;
          var businessNameForUpdate = clientData.business_name;
          var rfcForUpdate = clientData.rfc;
          var companyNameForUpdate = clientData.company_name;
          var clientNotesForUpdate = clientData.notes;
          localStorage.setItem('businessNameForUpdate', businessNameForUpdate);
          localStorage.setItem('clientNotesForUpdate', clientNotesForUpdate);
          localStorage.setItem('rfcForUpdate', rfcForUpdate);
          localStorage.setItem('companyNameForUpdate', companyNameForUpdate);
          localStorage.setItem('selectedRegionForUpdate', clientData.region_id);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  function manageClientDelete(clientInfo) {
    var clientId = clientInfo.id;
    localStorage.setItem('clientIdToDelete', clientId);

    var clientBusiness = clientInfo.business_name;
    var clientCreatedDate = clientInfo.created_at;
    localStorage.setItem('clientBusinessToDelete', clientBusiness);
    localStorage.setItem('clientCreatedDateToDelete', clientCreatedDate);
  }

  const [modalCMultipleDeleteShow, setModalCMultipleDeleteShow] =
    useState(false);

  function manageClientMultipleDelete() {
    localStorage.setItem('clientMultipleDeleteList', rowSelectionModel);
  }

  function manageClientLogs(clientInfo) {
    var clientId = clientInfo.id;
    localStorage.setItem('clientIdForLog', clientId);
    navigate('/clientLogs');
  }

  const actionColumn = [
    {
      field: 'action',
      headerName: detailString,
      headerClassName: 'clients-datagrid-actions-tour',
      width: 180,
      pinnable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isInactive =
          params.row.is_active === 'Inactivo' ||
          params.row.is_active === 2 ||
          params.row.is_active === '2';

        return (
          <div
            className="cellAction clients-datagrid-actions-tour"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              marginTop: '5px',
            }}
          >
            {/* ✏️ Editar */}
            {userPermissions.includes('Update Clients') && (
              <Tooltip title={editString} arrow>
                <button
                  type="button"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                  }}
                  onClick={async () => {
                    try {
                      await manageClientUpdate(params.row);
                      setModalCUpdateShow(true);
                    } catch (error) {
                      console.error(error);
                    }
                  }}
                >
                  <ModeEditOutlineOutlinedIcon
                    className="detail-icons"
                    id="update-icon"
                  />
                </button>
              </Tooltip>
            )}

            {/* 🔁 Activar / Inactivar */}
            {userPermissions.includes(isInactive ? 'Update Clients' : 'Delete Clients') && (
              <Tooltip
                title={isInactive ? 'Activar plaza' : 'Inactivar plaza'}
                arrow
              >
                <button
                  type="button"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                  }}
                  onClick={() => {
                    if (isInactive) {
                      // 🟢 Guardar info para activar
                      localStorage.setItem('clientIdToActivate', params.row.id);
                      localStorage.setItem(
                        'clientBusinessToActivate',
                        params.row.business_name,
                      );
                      localStorage.setItem(
                        'clientCreatedDateToActivate',
                        params.row.created_at,
                      );
                      setModalSActivateShow(true); // Mostrar modal de activación
                    } else {
                      // 🔴 Guardar info para inactivar (usa el modal existente)
                      manageClientDelete(params.row);
                      setModalCDeleteShow(true);
                    }
                  }}
                >
                  {isInactive ? (
                    <CheckCircleOutlineIcon
                      className="detail-icons"
                      id="activate-icon"
                      style={{ color: 'green' }}
                    />
                  ) : (
                    <BlockIcon
                      className="detail-icons"
                      id="deactivate-icon"
                      style={{ color: 'red' }}
                    />
                  )}
                </button>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  // Columnas
  const clientColumns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 100,
    },
    {
      field: 'business_name',
      headerName: clientClientString,
      width: 180,
    },
    // {
    //   field: 'company_name',
    //   headerName: clientMCCompanyNameString,
    //   width: 180,
    // },
    {
      field: 'region_name',
      headerName: 'Región',
      width: 180,
    },
    {
      field: 'full_name',
      headerName: clientContactNameString,
      width: 250,
      renderCell: (params) => {
        const full_name =
          params.row?.name && params.row?.last_name
            ? params.row.name + ' ' + params.row.last_name
            : '';
        return (
          <div>
            <span>{full_name}</span>
          </div>
        );
      },
    },
    {
      field: 'is_active',
      headerName: clientStatusString,
      width: 150,
      renderCell: (params) => {
        if (
          params.row.is_active === 'Activo' ||
          params.row.is_active === 'Active'
        ) {
          return (
            <div>
              <span className="statusActive">{params.row.is_active}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="statusInactive">{params.row.is_active}</span>
            </div>
          );
        }
      },
      valueGetter: (params) => params.row.is_active,
    },
    {
      field: 'created_at',
      headerName: createdAtString,
      width: 150,
    },
    {
      field: 'created_by',
      headerName: createdByString,
      width: 150,
    },
    {
      field: 'updated_at',
      headerName: updatedAtString,
      width: 150,
    },
    {
      field: 'updated_by',
      headerName: updatedByString,
      width: 150,
    },
    // {
    //   field: 'notes',
    //   headerName: 'Notas',
    //   width: 200,
    // },
    // Map through all columns and add default renderCell if not already defined
  ].map((col) =>
    col.renderCell
      ? col
      : {
          ...col,
          renderCell: (params) =>
            ['created_at', 'updated_at'].includes(col.field)
              ? formatDateDDMMYYYY(params.row[col.field])
              : params.row[col.field] || '-',
        },
  );

  // Check if user has any action permissions
  const hasActionPermissions =
    userPermissions.includes('Update Clients') ||
    userPermissions.includes('Delete Clients');

  return (
    <>
      <div className="datatable-btns-container">
        <div className="dt-btn-main-container">
          <span className="dabiWebText"> {clientsString} </span>
          {userPermissions.includes('Create Clients') && (
            <button
              className="add-button create-client-tour"
              onClick={() => setModalCShow(true)}
            >
              {addString} <FontAwesomeIcon icon={faAdd} />
            </button>
          )}
          {userPermissions.includes('Delete Clients') && (
            <button
              disabled={isButtonDisabled}
              onClick={() => {
                setModalCMultipleDeleteShow(true);
                manageClientMultipleDelete();
              }}
              className="multiple-delete-btn"
            >
              {multDeleteString}
            </button>
          )}
        </div>
        <Tooltip title={viewTutorialString}>
          <IconButton
            className="tour-button"
            size="medium"
            disabled={!userPermissions.includes('Create Clients')}
            onClick={() => restartTour()}
          >
            <FontAwesomeIcon icon={faCircleInfo} />
          </IconButton>
        </Tooltip>
      </div>

      <ModalC
        show={modalCShow}
        onHide={() => setModalCShow(false)}
        getClients={getData}
        className="create-client-form-tour"
      />

      <ModalCUpdate
        show={modalCUpdateShow}
        onHide={() => setModalCUpdateShow(false)}
        getClients={getData}
      />

      <ModalCMultDelete
        show={modalCMultipleDeleteShow}
        onHide={() => setModalCMultipleDeleteShow(false)}
        getClients={getData}
      />

      <ModalCDelete
        show={modalCDeleteShow}
        onHide={() => setModalCDeleteShow(false)}
        getClients={getData}
      />

      <ModalCActivate
        show={modalSActivateShow}
        onHide={() => setModalSActivateShow(false)}
        getClients={getData}
      />

      <DataGridPro
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        pagination
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'id', sort: 'desc' }],
          },
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
          pinnedColumns: hasActionPermissions ? { right: ['action'] } : {},
        }}
        rows={clientData}
        columns={
          hasActionPermissions
            ? clientColumns.concat(actionColumn)
            : clientColumns
        }
        checkboxSelection
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
          if (newRowSelectionModel.length >= 1) {
            setIsButtonDisabled(false);
          }
          if (newRowSelectionModel.length === 0) {
            setIsButtonDisabled(true);
          }
        }}
        rowSelectionModel={rowSelectionModel}
        slots={{
          noRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {noClientsString}
            </Stack>
          ),
          toolbar: GridToolbar,
        }}
        className="clients-datagrid-tour"
      />
    </>
  );
};
